import YearRoundScenarioView from '@/components/YearRoundScenarioView';
import { getStrategy } from '@/lib/yearRoundStrategies';

export default function StrategyContinuousFullPage() {
  const s = getStrategy('continuous_full');
  if (!s) return null;
  return <YearRoundScenarioView strategy={s} />;
}
